import { render, staticRenderFns } from "./DesktopMoreNav.vue?vue&type=template&id=1004c37d&scoped=true&"
import script from "./DesktopMoreNav.vue?vue&type=script&lang=ts&"
export * from "./DesktopMoreNav.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopMoreNav.vue?vue&type=style&index=0&id=1004c37d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004c37d",
  null
  
)

export default component.exports